import ApiService from '@/services/ApiService';

const ImportMailAddressService = {
  import(file) {
    return ApiService.post('imports', file)
  },
}

export default ImportMailAddressService